import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { FaFilter, FaTimes, FaChevronDown } from "react-icons/fa";
import { User, Mail, Phone, Send, Square } from "lucide-react";
import "./Products.css";
import ProductBanner from "../images/product-banner.png"
import FullScreenLoader from "../components/FullScreenLoader";

const Products = () => {

  //
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [pendingBrochure, setPendingBrochure] = useState(null);


  const handleReachOut = (context) => {
    setShowFormPopup(true);
    setFormSubmitted(false); // Reset form submission when opening popup
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // You can add form validation or API call here
    setFormSubmitted(true);
  };


  // 

  // Form PHP
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    // Optional: basic validation
    if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
      setResponseMessage("Please fill in all fields.");
      setLoading(false);
      return;
    }

    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/contact-form-premier-pumps.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody,
      });

      const result = await response.json();

      if (result.status === "success") {
        setResponseMessage("Message sent successfully! ✅");
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          message: "",
        });
        if (pendingBrochure) {
          const brochureToDownload = pendingBrochure;
          setShowThankYouPopup(false);
          setShowFormPopup(false);
          setPendingBrochure(null);
          triggerBrochureDownload(brochureToDownload);
          const formId = brochureToDownload.formId || "product";
          navigate(`/thank-you?formId=${encodeURIComponent(formId)}`, {
            state: {
              brochureUrl: brochureToDownload.url,
              brochureName: brochureToDownload.filename,
            },
          });
        } else {
          setShowFormPopup(false); // close form
          // setShowThankYouPopup(true); // open thank-you popup
          navigate("/thank-you?formId=products-sidebar");
        }
      } else {
        setResponseMessage("Error: " + result.message);
      }
    } catch (error) {
      setResponseMessage("Error sending message. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Form PHP

  const toFormId = (name) => {
    const base = String(name || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
    return base || "product";
  };

  const resolveBrochureFilename = (brochureUrl, brochureName) => {
    if (brochureName) return brochureName;
    if (!brochureUrl) return "brochure.pdf";
    const cleanUrl = String(brochureUrl).split(/[?#]/)[0];
    const lastSegment = cleanUrl.split("/").pop();
    return decodeURIComponent(lastSegment || "brochure.pdf");
  };

  const openBrochureForm = (brochureUrl, brochureName, productName) => {
    setResponseMessage("");
    setPendingBrochure({
      url: brochureUrl,
      filename: resolveBrochureFilename(brochureUrl, brochureName),
      formId: toFormId(productName),
    });
    setShowFormPopup(true);
  };

  const closeBrochureForm = () => {
    setResponseMessage("");
    setShowFormPopup(false);
    setPendingBrochure(null);
  };

  const triggerBrochureDownload = (brochure) => {
    if (!brochure?.url) return;
    const link = document.createElement("a");
    link.href = brochure.url;
    if (brochure.filename) {
      link.setAttribute("download", brochure.filename);
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const productsData = [
    {
      name: "PV SERIES",
      detail: "Capacity :<br /> 85 CFM TO 11,385 CFM <br />145 m³/h to 19,345 m³/h",
      image: require("../images/products/PV-SERIES.png"),
      category: "pv",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PV Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PV Series.pdf",
    },
    {
      name: "PREMIER SERIES",
      detail: "Capacity :<br />2,360 CFM to 13,225 CFM <br /> 4,010 m³/h to 22,470 m³/h",
      image: require("../images/products/PREMIER-SERIES.png"),
      category: "premier",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PREMIER Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PREMIER Series.pdf",
    },
    {
      name: "PVSC SERIES",
      detail: "Capacity :<br /> 70 CFM to 1,315 CFM  <br /> 120 m³/h to 2,235 m³/h",
      image: require("../images/products/PS-SERIES.png"),
      category: "ps",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PVSC Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PVSC Series.pdf",
    },
    {
      name: "PVXL SERIES",
      detail: "Capacity :<br /> 60 CFM to 3,510 CFM  <br /> 105 m³/h to 5,960 m³/h",
      image: require("../images/products/PXL-SERIES.png"),
      category: "pvxl",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PVXL Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PVXL Series.pdf",
    },
    {
      name: "P2BE SERIES",
      detail: "Capacity :<br /> 2,345 CFM  to 42,380 CFM <br />  4,000 m³/h to 72,000 m³/h",
      image: require("../images/products/P2BE-SERIES.png"),
      category: "p2be",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P2BE Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P2BE Series.pdf",
    },
    {
      name: "P501 SERIES",
      detail: "Capacity :<br /> 2,000 CFM to 19,550 CFM <br />3,400 m³/h to 33,215 m³/h",
      image: require("../images/products/P501-SERIES.png"),
      category: "p501",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P501 Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P501 Series.pdf",
    },
    {
      name: "PWS SERIES",
      detail: "Capacity :<br /> 105 CFM to 1,265 CFM <br /> 175 m³/h to 2,150 m³/h",
      image: require("../images/products/PVW-SERIES.png"),
      category: "pws",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PWS Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PWS Series.pdf",
    },
    {
      name: "PA SERIES",
      detail: "",
      image: require("../images/products/PA-140-SERIES.png"),
      category: "pa",
      brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PA Series.pdf"),
      brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PA Series.pdf",
    },
    {
      name: "PAT SERIES",
      detail: "",
      image: require("../images/products/PAT-SERIES.png"),
      category: "pat",
      brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PAT Series.pdf"),
      brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PAT Series.pdf",
    },
    {
      name: "PSHR SERIES",
      detail: "",
      image: require("../images/products/PSHR-SERIES.png"),
      category: "pshr",
      brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PSHR Series.pdf"),
      brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PSHR Series.pdf",
    },
    {
      name: "PTC SERIES",
      detail: "",
      image: require("../images/products/PTC-SERIES.png"),
      category: "ptc",
      brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PTC Series.pdf"),
      brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PTC Series.pdf",
    },
    {
      name: "PLH SERIES",
      detail: "Capacity :<br /> 70 CFM to 410 CFM <br />  120 m³/h to 695 m³/h",
      image: require("../images/products/PLH -SERIES.png"),
      category: "plh",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PLH Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PLH Series.pdf",
    },
    {
      name: "WXP SERIES",
      detail: "",
      image: require("../images/products/WXP-SERIES.png"),
      category: "wxp",
      brochure: require("../images/new-brochures/Dewatering Vacuum Pumps_WXP Series.pdf"),
      brochureName: "Dewatering Vacuum Pumps_WXP Series.pdf",
    },
    {
      name: "P9000",
      detail: "Capacity :<br /> 5,750 CFM to 13,570 CFM <br />  9,770 m³/h to 23,060 m³/h",
      image: require("../images/products/P9000-SERIES.png"),
      category: "p9000",
      brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P9000 Series.pdf"),
      brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P9000 Series.pdf",
    },
  ];



  // Filter Logic
  const [filteredProducts, setFilteredProducts] = useState(productsData);
  const [activeCategory, setActiveCategory] = useState("all"); // Default active is "All Products"

  // Filter Products
  const handleFilter = (category) => {
    if (category === "all") {
      setFilteredProducts(productsData);
    } else {
      setFilteredProducts(productsData.filter((product) => product.category === category));
    }
    setActiveCategory(category); // Update active category
  };

  return (
    <div className="Products container">
      {loading && <FullScreenLoader label="Sending..." />}
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="breadcrumb-nav">

        <div className="d-flex justify-content-between container p-0">
          <h5 className="fw-bold">Products</h5>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <NavLink to="/" className="text-dark">Home</NavLink>
            </li>
            <li className="breadcrumb-item">
              <NavLink to="/products" className="text-dark">Products</NavLink>
            </li>
            {/* <li className="breadcrumb-item active text-primary fw-bold" aria-current="page">
              PV SERIES
            </li> */}
          </ol>
        </div>
      </nav>

      <div className="container-fluid p-0">
        <div className="container p-0">
          <div className="row">
            {/* Left Sidebar */}
            <div className={`col-lg-3 sidebar ${showSidebar ? "show" : ""}`}>
              <div className="py-md-0 py-4">


                {/* Close Icon */}
                <div className="close-icon d-lg-none d-block" onClick={toggleSidebar}>
                  <FaTimes size={24} />
                </div>

                {/* Filter Navigation */}
                <ul className="list-group product-filter">
                  <li className=" list-item">
                    <Link to="/products" className="text-decoration-none d-block text-blue">All Products</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/pv" className="text-decoration-none d-block">PV Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/premier" className="text-decoration-none d-block">PREMIER Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/ps" className="text-decoration-none d-block">PVSC Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/pvxl" className="text-decoration-none d-block">PVXL Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/p2be" className="text-decoration-none d-block">P2BE Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/p501" className="text-decoration-none d-block">P501 Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/pws" className="text-decoration-none d-block">PWS Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/pa" className="text-decoration-none d-block">PA Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/pat" className="text-decoration-none d-block">PAT Series</Link>
                  </li>

                  <li className="list-item">
                    <Link to="/product-details/pshr" className="text-decoration-none d-block">PSHR Series</Link>
                  </li>

                  <li className="list-item">
                    <Link to="/product-details/ptc" className="text-decoration-none d-block">PTC Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/plh" className="text-decoration-none d-block">PLH Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/wxp" className="text-decoration-none d-block">WXP Series</Link>
                  </li>
                  <li className="list-item">
                    <Link to="/product-details/p9000" className="text-decoration-none d-block">P9000</Link>
                  </li>
                </ul>

                <div className="subscribe-box mt-4">
                  {/* <div className="subscribe-header">
                  <Square size={14} className="icon-square text-blue" /> Join with us
                </div> */}
                  <div className="form-container">
                    <h5 className="fw-bold text-blue mb-4 text-center">Reach out to us !</h5>
                    {!formSubmitted ? (
                      <form onSubmit={handleSubmit}>
                        <div className="input-group flex-column">

                          {/* Full Name */}
                          <label className="fw-medium">
                            Name <span className="text-danger">*</span>
                          </label>
                          <div className="input-wrapper rounded-20">
                            <div className="d-flex align-items-center">
                              <User size={20} className="input-icon text-blue me-2" />
                              <input
                                name="fullName"
                                type="text"
                                placeholder="Enter your name"
                                className="form-control border-start rounded-0 ps-2"
                                required
                                value={formData.fullName}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {/* Email */}
                          <label className="fw-medium">
                            Email <span className="text-danger">*</span>
                          </label>
                          <div className="input-wrapper rounded-20">
                            <div className="d-flex align-items-center">
                              <Mail size={20} className="input-icon text-blue me-2" />
                              <input
                                name="email"
                                type="email"
                                placeholder="Enter your email"
                                className="form-control border-start rounded-0 ps-2"
                                required
                                value={formData.email}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {/* Phone */}
                          <label className="fw-medium">Phone</label>
                          <div className="input-wrapper rounded-20">
                            <div className="d-flex align-items-center">
                              <Phone size={20} className="input-icon text-blue me-2" />
                              <input
                                name="phone"
                                type="tel"
                                placeholder="Enter your phone number"
                                className="form-control border-start rounded-0 ps-2"
                                value={formData.phone}
                                onChange={handleChange}
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                    "Tab", "Home", "End", "+", "-", "(", ")", " "
                                  ];
                                  const isNumber = /^[0-9]$/.test(e.key);
                                  const isAllowed = allowedKeys.includes(e.key);
                                  if (!isNumber && !isAllowed) e.preventDefault();
                                }}
                              />
                            </div>
                          </div>

                          {/* Message */}
                          <label className="fw-medium mt-3">Message</label>
                          <div className="input-wrapper rounded-20">
                            <textarea
                              name="message"
                              placeholder="Your Message"
                              rows="4"
                              className="form-control rounded-0 ps-2"
                              required
                              value={formData.message}
                              onChange={handleChange}
                            />
                          </div>

                          {/* Submit Button */}
                          <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                              {loading ? "Sending..." : "Submit"}
                            </button>
                          </div>
                        </div>

                        {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                      </form>
                    ) : (
                      <div className="text-center p-4">
                        <p>Thank you for reaching out! We'll get back to you soon.</p>
                        <button
                          className="btn btn-primary mt-3 px-4"
                          onClick={() => {
                            setFormSubmitted(false);
                            setShowThankYouPopup(false);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

            </div>

            {/* Right Content Section */}
            <div className="col-lg-9 content">
              {/* Banner */}
              <div className="product-banner py-5 ps-5 rounded">
                <div className="row align-items-center justify-content-center">
                  <div className="col-4">
                    <h3 className="text-white fw-bold">Explore Our Products</h3>
                  </div>
                  <div className="col-8">
                    <img
                      src={ProductBanner}
                      alt="Banner"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
              {/* Filter Icon - Toggles Sidebar */}
              <div className="d-lg-none filter-icon mt-3 position-fixed" onClick={toggleSidebar}>
                <FaFilter size={24} />
                {/* <p>Filter</p> */}
              </div>

              <div className="row">
                {filteredProducts.map((product, index) => (
                  <div key={index} className="col-lg-4 col-6 my-3">
                    {/* <Link to={`/product-details/${product.category}`} className="text-decoration-none">
                      <div className="product-card p-5 text-center h-100 d-flex align-items-center flex-column justify-content-between">
                        <img src={product.image} alt={product.name} className="img-fluid product-img" />
                        <h5 className="product-name">{product.name}</h5>
                        <div className="capacity">
                        </div>
                        <p className="product-capacity" dangerouslySetInnerHTML={{ __html: product.detail }}></p>

                        <button className="btn btn-outline-primary mt-2 d-flex align-items-center">
                          Download Brochure <FaChevronDown className="ms-2" size={14} />
                        </button>
                      </div>
                    </Link> */}
                    <div className="product-card p-md-4 p-2 py-4 text-center h-100 d-flex align-items-center flex-column justify-content-between">
                      {/* Clickable product card */}
                      <Link to={`/product-details/${product.category}`} className="text-decoration-none w-100 d-flex justify-content-center flex-column">
                        <img src={product.image} alt={product.name} className="img-fluid product-img" />
                        <h5 className="product-name">{product.name}</h5>
                        <div className="capacity d-flex justify-content-center">
                          {/* {product.detail && <p className="product-detail">{product.detail}</p>} */}
                        </div>
                        <p className="product-capacity text-start fs-sm-10" dangerouslySetInnerHTML={{ __html: product.detail }}></p>
                      </Link>

                      {/* Download Brochure Button */}
                      {product.brochure && (
                        <a
                          href={product.brochure}
                          download={product.brochureName}
                          className="btn btn-outline-primary mt-2 d-flex align-items-center fs-sm-10"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openBrochureForm(
                              product.brochure,
                              product.brochureName,
                              product.name
                            );
                          }}
                        >
                          Download Brochure <FaChevronDown className="ms-2" size={14} />
                        </a>
                      )}
                    </div>

                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* brochure form popup */}
      {showFormPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header d-flex justify-content-center align-items-center">
              <h5>Download Brochure</h5>
              <button
                className="btn-close fs-4"
                onClick={closeBrochureForm}
              >
                ×
              </button>
            </div>
            <div className="form-container">
              <form onSubmit={handleSubmit}>
                <div className="input-group flex-column">
                  {/* Full Name */}
                  <label className="fw-medium">
                    Name <span className="text-danger">*</span>
                  </label>
                  <div className="input-wrapper rounded-20 my-1 p-2">
                    <div className="d-flex align-items-center">
                      <User size={20} className="input-icon text-blue me-2" />
                      <input
                        id="brochure-fullName"
                        name="fullName"
                        type="text"
                        placeholder="Enter your name"
                        className="form-control border-start rounded-0 ps-2"
                        required
                        value={formData.fullName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <label className="fw-medium">
                    Email <span className="text-danger">*</span>
                  </label>
                  <div className="input-wrapper rounded-20 my-1 p-2">
                    <div className="d-flex align-items-center">
                      <Mail size={20} className="input-icon text-blue me-2" />
                      <input
                        id="brochure-email"
                        name="email"
                        type="email"
                        placeholder="Enter your email"
                        className="form-control border-start rounded-0 ps-2"
                        required
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  <label className="fw-medium">Phone</label>
                  <div className="input-wrapper rounded-20 my-1 p-2">
                    <div className="d-flex align-items-center">
                      <Phone size={20} className="input-icon text-blue me-2" />
                      <input
                        id="brochure-phone"
                        name="phone"
                        type="tel"
                        placeholder="Enter your phone number"
                        className="form-control border-start rounded-0 ps-2"
                        value={formData.phone}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                            "Tab",
                            "Home",
                            "End",
                            "+",
                            "-",
                            "(",
                            ")",
                            " ",
                          ];
                          const isNumber = /^[0-9]$/.test(e.key);
                          const isAllowed = allowedKeys.includes(e.key);
                          if (!isNumber && !isAllowed) e.preventDefault();
                        }}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <label className="fw-medium mt-3">Message</label>
                  <div className="input-wrapper rounded-20 my-1 p-2">
                    <textarea
                      id="brochure-message"
                      name="message"
                      placeholder="Your Message"
                      rows="4"
                      className="form-control rounded-0 ps-2"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Submit */}
                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                      {loading ? "Sending..." : "Submit"}
                    </button>
                  </div>
                </div>
                {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
              </form>
            </div>
          </div>
        </div>
      )}

      {/* thank you popup  */}

      {showThankYouPopup && (
        <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
          <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
            <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
              <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
              <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.com' >support@premierpumps.com</a></p>
              <button
                className="btn btn-primary mt-3 px-4"
                onClick={() => setShowThankYouPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


      {/* thank you popup  */}
    </div>
  );
};

export default Products;
